import axios from '@/axios'

const accountinfo = {
  //获取账户资料基本信息
  async getIdentityInfo(params = '') {
    return await axios.post('/uc/user/userinfo/identityInfoPc', params, { des: '直客pc获取账户资料基本信息', sTime: new Date().getTime() })
  },
  //获取模拟客户基本资料 /uc/simulator/identityInfo
  async getSimulatorInfo(params = '') {
    return await axios.post('/uc/simulator/identityInfo', params, { des: '直客pc获取模拟客户基本资料', sTime: new Date().getTime() })
  },
  //发送验证码接口  /uc/sendcode
  async sendValidateCode(params) {
    return await axios.post('/uc/sendcode', params, { des: '直客pc发送验证码接口', sTime: new Date().getTime() })
  },
  //公共发送验证码接口
  async publicSendCode(params,data) {
    let url = params.url
    data = { sendType: 1, ...data}
    return await axios.post(url, data, { des: '直客pc公共发送验证码接口', sTime: new Date().getTime() })
  },
  //真实客户/模拟账户修改密码 
  async resetPassword(params) {
    let url = params.url
    let data = params.data
    return await axios.post(url, data, { des: '直客pc真实客户/模拟账户修改密码 ', sTime: new Date().getTime() })
  },

  //银行卡列表 
  async getBankList(params = '') {
    return await axios.post('/uc/user/bank/list', params, { des: '直客pc银行卡列表', sTime: new Date().getTime() })
  },
  //查看银行卡详情 /uc/user/bank/detail
  async getBankDetail(params) {
    return await axios.post('/uc/user/bank/detail', params, { des: '直客pc查看银行卡详情', sTime: new Date().getTime() })
  },
  //银行卡资料修改 /uc/user/bank/update
  async putBankDetail(params) {
    return await axios.post('/uc/user/bank/update', params, { des: '直客pc修改银行卡详情', sTime: new Date().getTime() })
  },
  //银行卡资料解除绑定   /uc/user/bank/removebind
  async removeCard(params) {
    return await axios.post('/uc/user/bank/removebind', params, { des: '直客pc银行卡资料解除绑定', sTime: new Date().getTime() })
  },
  //提交身份证照片信息 /uc/user/userinfo/identityInfoSubmit
  async submitCardImg(params) {
    return await axios.post('/uc/user/userinfo/identityInfoSubmit', params, { des: '直客pc提交身份证照片信息 ', sTime: new Date().getTime() })
  },
  async uploadImg(params = '') {
    return await axios.post('/uc/user/userinfo/identityinfoimg', params, { des: '直客pc上传图片', sTime: new Date().getTime() })
  },
  //银行卡资料新增  /uc/user/bank/add
  async addBankCard(params) {
    return await axios.post('/uc/user/bank/add', params, { des: '直客pc银行卡资料新增', sTime: new Date().getTime() })
  },
  // 根据卡号获取银行名称
  async getBankNameByNumber(params) {
    return await axios.get('/uc/bank/matchingBank', params, { des: '直客pc根据卡号获取银行名称', sTime: new Date().getTime() })
  },
  //新版实名认证接口
  async submitInfo(params) {
    return await axios.post('/uc/user/userinfo/identityInfoSubmitI', params, { des: '直客wap提交账户资料信息', sTime: new Date().getTime() })
  },
}

export default accountinfo


// WEBPACK FOOTER //
// ./src/api/accountinfo.js